import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getCalenderDetailSlice = createSlice({
    name: 'CalenderDetail',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchCalenderDetail.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchCalenderDetail.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchCalenderDetail.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setCalenderDetail, setStatus } = getCalenderDetailSlice.actions;
export default getCalenderDetailSlice.reducer;

export const fetchCalenderDetail = createAsyncThunk('/CalenderDetailget/fetch', async ({start}) => {
    const res = await axios.get(`${getBaseUrl()}/RaceCardCalenderDetail/${start}`);
    const CalenderDetailData = res.data;
    return CalenderDetailData.data;
})
